export enum ComponentBlock {
  PlanetFilterStage = 0,
  PlanetFilterStatus,
  StarFilterStatus,
  ApostleFilterPurchaseType,
  ApostleFilterStatus
}
